const pathBindingCache = {};

export function getPathBindings(settings, isEmbedDemo) {
  const iframe_pathBinding = settings.iframe_pathBinding;
  const key = `${iframe_pathBinding}-${isEmbedDemo}`;

  if (pathBindingCache[key] !== undefined) {
    return pathBindingCache[key];
  }

  const json = JSON.parse(iframe_pathBinding || "{}");

  const pathBindings = Object.entries(json).reduce(
    (acc, [pKey, boundToPath]) => {
      if (!boundToPath) return acc;
      if (!PATH_BINDING_GROUPS[pKey]) return acc;

      if (isEmbedDemo) {
        boundToPath = "/EmbedDemo/" + boundToPath;
      }

      const value = `/${boundToPath}` // ensure leading slash
        .replace(/\/{2,}/g, "/") // remove double slashes
        .replace(/\/$/, ""); // remove trailing slash;

      acc[pKey] = {
        ...PATH_BINDING_GROUPS[pKey],
        value,
      };

      return acc;
    },
    {}
  );

  pathBindingCache[key] = pathBindings;
  return pathBindingCache[key];
}

window.getPathBindings = getPathBindings;

export function replaceCvpageParameterWithPathBinding(
  settings,
  url,
  isEmbedDemo
) {
  const boundGroups = getPathBindings(settings, isEmbedDemo);

  const _url = new URL(url);

  const qs = _url.searchParams;
  const cvpage = qs.get("cvpage");

  const cvPageFirstPart = (cvpage ?? "").split("/")[0];

  let group = Object.values(boundGroups).find((group) => {
    // ignore subpath when finding group
    return group.pages.find((page) => {
      return page === cvPageFirstPart;
    });
  });

  if (!group && boundGroups.FALLBACK) {
    group = boundGroups.FALLBACK;
  }

  if (!group) return { url, didReplace: false };

  if (group.pages.length > 0 && group.pages[0] === cvpage) {
    qs.delete("cvpage");
  }

  const newUrl = new URL(_url.origin);
  newUrl.pathname = group.value;
  newUrl.search = qs.toString();

  return { cvpage, url: newUrl.toString(), didReplace: true };
}

window.replaceCvpageParameterWithPathBinding =
  replaceCvpageParameterWithPathBinding;

export const PATH_BINDING_GROUPS = {
  FALLBACK: {
    key: "FALLBACK", // key is uppercase of first page
    pages: [],
    example: "/medarbeiderportal",
    value: null,
    fallback: true,
  },
  JOBS: {
    key: "JOBS",
    pages: ["jobs", "job"], // key is uppercase of first page
    example: "/ledige-stillinger",
    value: null,
  },
  TIMESHEETS: {
    key: "TIMESHEETS", // key is uppercase of first page
    pages: ["timesheets", "timesheet"],
    example: "/timelister",
    value: null,
  },
  MESSAGES: {
    key: "MESSAGES", // key is uppercase of first page
    pages: ["messages"],
    example: "/postkasse",
    value: null,
  },
};

export function getCurrentPathBinding(hostUrl, settings, isEmbedDemo) {
  if (!hostUrl) return null;

  const hostUrlPath = new URL(hostUrl).pathname;

  const bindings = getPathBindings(settings, isEmbedDemo);

  for (const pGroup of Object.values(bindings)) {
    if (hostUrlPath.endsWith(pGroup.value)) {
      return pGroup;
    }
  }

  return null;
}
